import logo from './logo.svg';
import './App.css';
import Header from './Components/Header/Header';
import Topbar from './Components/topheader/Topheader';
import Navbar from './Components/navbar/Navbar';
import Servicessetion from './Components/servicessection/Servicesection';
import FeaturesSection from './Components/featuresection/Featuresection';
import PortfolioSection from './Components/portfoliosection/Portfoliosection';
import PricingSection from './Components/pricesection/Pricesection';
import LogoPricing from './Components/Logodesign/Logodesign';
import DigitalMarketingPricing from './Components/digitalmarketing/Digitalmarking';
import Testimonials from './Components/testimonial/Testimonial';
import OurClients from './Components/ourclients/Ourclients';
import FAQ from './Components/faqpage/FAQ';
import Footer from './Components/footer/Footer';
import Contactpage from './Components/contactpage/Contactpage';
import Popupboxx from './Components/Popupbox/Popupbox';
import { useEffect, useState } from 'react';
import Tools from './Components/tools/Tools';


function App() {

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Open popup after 9 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPopupOpen(true);
    }, 9000); // 9000ms = 9 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div className="App"
    //  style={{ backgroundColor: "#d9e1f1 ", minHeight: "100vh" }}
     >
       <Popupboxx isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      <Topbar />
    
      {/* <Navbar/> */}
      <Header />
      <Servicessetion />
      

      <PricingSection />
      <LogoPricing />
      <DigitalMarketingPricing />
      <FeaturesSection />
      <PortfolioSection />
      <Tools />
      <FAQ />
      <Testimonials />
      <Contactpage/>
      <Footer/>

    </div>

  );
}

export default App;
